var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs, _clipPath, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEsOrderSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "148px",
    height: "144px",
    viewBox: "0 0 148 144",
    enableBackground: "new 0 0 148 144",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M147.3,72c0-39.9-32.4-72-72.2-72C52.2,0,31.8,10.6,18.6,27.2C8.8,39.5,2.9,55.1,2.9,72 c0,24.1,11.9,45.6,30.4,58.8c11.8,8.3,26.2,13.3,41.7,13.3C115.1,144,147.3,111.6,147.3,72z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C6D4E7",
    d: "M143.4,16.9c1.4-1.2,1.6-3.4,0.3-4.9s-3.4-1.6-4.9-0.4c-1.4,1.2-1.6,3.4-0.4,4.9 C139.7,18,141.9,18.2,143.4,16.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C6D4E7",
    d: "M145.1,25.2c0.9-0.8,1-2.2,0.2-3.1s-2.2-1-3.1-0.2c-0.9,0.8-1,2.2-0.2,3.1S144.2,26,145.1,25.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#C6D4E7",
    d: "M5.9,120.6c1.4-1.2,1.6-3.4,0.3-4.9c-1.2-1.4-3.4-1.6-4.9-0.4c-1.4,1.2-1.6,3.4-0.4,4.9 C2.2,121.7,4.4,121.9,5.9,120.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#C6D4E7",
    d: "M121.8,120.3c0,5-4.1,9.1-9.1,9.1s-9.1-4-9.1-9.1c0-5,4.1-9.1,9.1-9.1C117.8,111.2,121.8,115.2,121.8,120.3z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#C6D4E7",
    d: "M51.6,119.9L34.8,23.6h-6.2l17,97.3c0.3,1.5,1.5,2.5,3,2.5c0.2,0,0.4,0,0.5,0 C50.8,123.2,51.9,121.6,51.6,119.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#C6D4E7",
    d: "M56.9,120.3c0,5-4.1,9.1-9.1,9.1s-9.1-4-9.1-9.1c0-5,4.1-9.1,9.1-9.1C52.8,111.2,56.9,115.2,56.9,120.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#C6D4E7",
    d: "M111.8,117.4H35L16.1,23.6H9.8L29.4,121c0.3,1.4,1.5,2.4,3,2.4h79.3c1.7,0,3-1.4,3-3 C114.9,118.8,113.5,117.4,111.8,117.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#C6D4E7",
    d: "M131.5,40.2l-10.2,54.2c-0.7,3.9-4.2,6.8-8.2,6.8H92.9c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1 c3,0,5.6-2.2,6.2-5.1l10.2-54.2c0.1-0.5,0.5-0.8,1-0.8h20.2c0.3,0,0.6,0.1,0.8,0.4C131.4,39.6,131.5,39.9,131.5,40.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.3608,
    y1: -57.9,
    x2: 111.3,
    y2: -57.9,
    gradientTransform: "matrix(1 0 0 1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4F0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EEF6FF"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M111.3,40.2l-10.2,54.2c-0.8,3.9-4.2,6.8-8.2,6.8H32.2c-4,0-7.4-2.8-8.2-6.7L13.4,40.2 c-0.1-0.3,0-0.6,0.2-0.8s0.5-0.4,0.8-0.4h96c0.3,0,0.6,0.1,0.8,0.4C111.3,39.6,111.3,39.9,111.3,40.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1DDEE",
    d: "M40.7,120.3c0,5-4.1,9.1-9.1,9.1s-9.1-4-9.1-9.1c0-5,4.1-9.1,9.1-9.1C36.6,111.2,40.7,115.2,40.7,120.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155110196539017151120000005579111635242211204_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.7105,
    y1: -7.7,
    x2: 35.5346,
    y2: -7.7,
    gradientTransform: "matrix(1 0 0 1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    style: {
      stopColor: "#E4F0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EEF5FF"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000155110196539017151120000005579111635242211204_)",
    d: "M35.5,120.3c0,2.2-1.7,3.9-3.9,3.9 s-3.9-1.7-3.9-3.9c0-2.2,1.7-3.9,3.9-3.9S35.5,118.1,35.5,120.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1DDEE",
    d: "M105.8,120.3c0,5-4.1,9.1-9.1,9.1s-9.1-4-9.1-9.1c0-5,4.1-9.1,9.1-9.1C101.7,111.2,105.8,115.2,105.8,120.3z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039843726231274931390000004830082591133161877_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.7613,
    y1: -7.7,
    x2: 100.5852,
    y2: -7.7,
    gradientTransform: "matrix(1 0 0 1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    style: {
      stopColor: "#E4F0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EEF5FF"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000039843726231274931390000004830082591133161877_)",
    d: "M100.6,120.3c0,2.2-1.7,3.9-3.9,3.9 s-3.9-1.7-3.9-3.9c0-2.2,1.7-3.9,3.9-3.9C98.8,116.4,100.6,118.1,100.6,120.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#C6D4E7",
    d: "M38.4,22.7v3.1c0,0.8-0.7,1.5-1.5,1.5H5.8c-2.3,0-4.4-1.4-5.4-3.5l-0.3-0.6c-0.4-1,0.3-2.1,1.3-2.1h35.4 C37.7,21.2,38.4,21.8,38.4,22.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000085224583386881183680000013481110198629678482_",
    x: 44.5,
    y: 43,
    width: 59,
    height: 58
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127747808490243550520000005567671315626960023_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085224583386881183680000013481110198629678482_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000127747808490243550520000005567671315626960023_)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108991625897852805410000003731228210179325082_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.2706,
    y1: -40.1462,
    x2: 91.5474,
    y2: -78.0031,
    gradientTransform: "matrix(1 0 0 1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F01A72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5261C"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#SVGID_00000108991625897852805410000003731228210179325082_)",
    d: " M59.2,43c-3.9,0-7.7,1.5-10.4,4.2c-2.8,2.7-4.3,6.4-4.3,10.3v29c0,3.8,1.6,7.5,4.3,10.3c2.8,2.7,6.5,4.2,10.4,4.2h29.5 c3.9,0,7.7-1.5,10.4-4.2c2.8-2.7,4.3-6.4,4.3-10.3v-29c0-3.8-1.6-7.5-4.3-10.3c-2.8-2.7-6.5-4.2-10.4-4.2H59.2z M88.8,64.6 c0.5-0.6,0.8-1.5,0.7-2.3c-0.1-0.8-0.5-1.6-1.2-2.1s-1.5-0.8-2.3-0.7s-1.6,0.5-2.1,1.1l-15,18.5l-6-4.4c-0.3-0.2-0.7-0.4-1.1-0.5 c-0.4-0.1-0.8-0.1-1.2-0.1c-0.4,0.1-0.8,0.2-1.2,0.4c-0.4,0.2-0.7,0.5-0.9,0.8S58.1,76,58,76.4s-0.1,0.8-0.1,1.2 c0.1,0.4,0.2,0.8,0.4,1.1c0.2,0.4,0.5,0.7,0.8,0.9l8.4,6.2c0.7,0.5,1.5,0.7,2.3,0.6s1.6-0.5,2.1-1.1L88.8,64.6z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsOrderSuccess);
export default __webpack_public_path__ + "static/media/es-order-success.cc7b503a542969ab4109caa8723c8ef8.svg";
export { ForwardRef as ReactComponent };